import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { ErrorPopoutComponent } from './error-popout.component';

@NgModule({
  imports: [
    CommonModule,
    PortalModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatListModule,
    RouterModule,
  ],
  declarations: [ErrorPopoutComponent],
  exports: [ErrorPopoutComponent],
})
export class RecipientsErrorPopoutModule {}
